import { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { statsApi } from '../api';
import { useAuth } from '../context/AuthContext';

function StatCard({ label, valor, color, icon }) {
  return (
    <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: '1.5rem', flex: 1, minWidth: 160 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
        <div style={{ fontSize: 13, color: '#aaa' }}>{label}</div>
        <span style={{ fontSize: 22 }}>{icon}</span>
      </div>
      <div style={{ fontSize: 40, fontWeight: 700, color: color || '#fff', lineHeight: 1 }}>{valor}</div>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [cargando, setCargando] = useState(true);
  const { usuario } = useAuth();

  useEffect(() => {
    statsApi()
      .then(r => setStats(r.data))
      .catch(console.error)
      .finally(() => setCargando(false));
  }, []);

  const hora = new Date().getHours();
  const saludo = hora < 12 ? 'Buenos dias' : hora < 18 ? 'Buenas tardes' : 'Buenas noches';

  return (
    <Layout titulo="Dashboard">
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#fff', marginBottom: 4 }}>
          {saludo}, {usuario?.nombre}
        </h1>
        <p style={{ fontSize: 14, color: '#666' }}>Resumen del sistema de soporte tecnico</p>
      </div>

      {cargando ? (
        <p style={{ color: '#555', textAlign: 'center', padding: '2rem' }}>Cargando...</p>
      ) : (
        <>
          <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: '2rem' }}>
            <StatCard label="Tickets abiertos"    valor={stats?.abiertos         ?? 0} color="#60a5fa" icon="🎫" />
            <StatCard label="En proceso"          valor={stats?.en_proceso        ?? 0} color="#fbbf24" icon="⚙️" />
            <StatCard label="Sin asignar"         valor={stats?.sin_asignar       ?? 0} color="#f87171" icon="⚠️" />
            <StatCard label="Cerrados hoy"        valor={stats?.cerrados_hoy      ?? 0} color="#4ade80" icon="✅" />
            <StatCard label="Clientes activos"    valor={stats?.clientes_activos  ?? 0} color="#a78bfa" icon="🏥" />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: '1.25rem' }}>
              <p style={{ fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 12 }}>Accesos rapidos</p>
              {[
                { label: 'Ver todos los tickets', path: '/tickets', icon: '🎫' },
                { label: 'Gestionar clientes', path: '/clientes', icon: '🏥' },
                { label: 'Ver implementaciones', path: '/implementaciones', icon: '🔧' },
                { label: 'Ver reportes', path: '/reportes', icon: '📊' },
              ].map(item => (
                <a key={item.path} href={item.path} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderBottom: '1px solid #1f1f1f', textDecoration: 'none', color: '#aaa', fontSize: 13 }}
                  onMouseEnter={e => e.currentTarget.style.color = '#4a9fd4'}
                  onMouseLeave={e => e.currentTarget.style.color = '#aaa'}>
                  <span>{item.icon}</span> {item.label}
                </a>
              ))}
            </div>

            <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: '1.25rem' }}>
              <p style={{ fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 12 }}>Estado del sistema</p>
              {[
                { label: 'Base de datos', estado: 'Conectada', color: '#4ade80' },
                { label: 'Servidor web', estado: 'Activo', color: '#4ade80' },
                { label: 'Servicio de email', estado: 'Configurado', color: '#4ade80' },
              ].map(item => (
                <div key={item.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #1f1f1f' }}>
                  <span style={{ fontSize: 13, color: '#aaa' }}>{item.label}</span>
                  <span style={{ fontSize: 12, color: item.color, fontWeight: 600 }}>● {item.estado}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </Layout>
  );
}